import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { formatDateTime } from "../../lib/format";
import { useTenantStore } from "../../stores/tenant";
import { Badge } from "../../components/ui/badge";
import { Button } from "../../components/ui/button";
import type { Callback } from "@shared/types";

export function CallbacksList() {
  const tenantId = useTenantStore((s) => s.currentTenantId);
  const [callbacks, setCallbacks] = useState<Callback[]>([]);

  const refresh = () => {
    if (!tenantId) return;
    api<Callback[]>(`/api/tenants/${tenantId}/callbacks`)
      .then(setCallbacks)
      .catch(() => setCallbacks([]));
  };

  useEffect(refresh, [tenantId]);

  const markDone = async (id: string) => {
    if (!tenantId) return;
    await api(`/api/tenants/${tenantId}/callbacks/${id}`, {
      method: "PATCH",
      body: JSON.stringify({ status: "done" }),
    });
    refresh();
  };

  return (
    <div>
      <header className="page-header">
        <div className="page-header__titles">
          <h1 className="page-header__title">Rappels à faire</h1>
          <p className="page-header__subtitle">Les rappels demandés par les appelants.</p>
        </div>
      </header>
      <table className="table">
        <thead>
          <tr>
            <th>Reçu</th>
            <th>Caller</th>
            <th>Téléphone</th>
            <th>Raison</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {callbacks.length === 0 ? (
            <tr>
              <td colSpan={6} className="table__empty">
                Aucun rappel en attente
              </td>
            </tr>
          ) : (
            callbacks.map((c) => (
              <tr key={c.id}>
                <td>{formatDateTime(c.createdAt)}</td>
                <td>{c.callerName ?? "Anonyme"}</td>
                <td style={{ fontFamily: "var(--mono)" }}>{c.callerPhone}</td>
                <td>{c.reason}</td>
                <td>
                  <Badge variant={c.status === "pending" ? "warning" : "success"}>{c.status}</Badge>
                </td>
                <td className="table__actions">
                  {c.status === "pending" ? (
                    <Button size="sm" variant="ghost" onClick={() => markDone(c.id)}>
                      Marquer fait
                    </Button>
                  ) : null}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
